/**
 * Iter52.63 · P1 · Pasos con estado, reutilizable en todas las cargas.
 *
 * Tres estados por paso:
 *   · hecho      → verde con ✓
 *   · siguiente  → color fuerte (solo UNO a la vez)
 *   · bloqueado  → gris
 */
import React from 'react';
import { Check } from 'lucide-react';

export const PasosCarga = ({ pasos, actual, testid = 'pasos-carga' }) => (
  <div className="flex items-center gap-2 flex-wrap" data-testid={testid}>
    {pasos.map((titulo, i) => {
      const estado = i < actual ? 'hecho' : i === actual ? 'siguiente' : 'bloqueado';
      const clases = {
        hecho: 'bg-emerald-50 border-emerald-300 text-emerald-800',
        siguiente: 'bg-emerald-600 border-emerald-700 text-white shadow-sm',
        bloqueado: 'bg-slate-50 border-slate-200 text-slate-400',
      }[estado];
      return <React.Fragment key={titulo}>
        <span data-testid={`${testid}-paso-${i}`} data-estado={estado}
              className={`inline-flex items-center gap-1.5 border rounded-full px-3 py-1 text-xs font-bold ${clases}`}>
          {estado === 'hecho' ? <Check className="w-3.5 h-3.5"/> : <span className="tabular-nums opacity-70">{i + 1}</span>}
          {titulo}
        </span>
        {i < pasos.length - 1 && <span className={`h-px w-5 ${i < actual ? 'bg-emerald-400' : 'bg-slate-200'}`}/>}
      </React.Fragment>;
    })}
  </div>
);
